import Thumb_Skin_plastic from './icons/options/skin/Thumb_Skin_plastic.png';
import Thumb_Skin_chrome from './icons/options/skin/Thumb_Skin_chrome.png';
import Thumb_Skin_gold from './icons/options/skin/Thumb_Skin_gold.png';
import Thumb_Skin_iridescent from './icons/options/skin/Thumb_Skin_iridescent.png';

export const character = {
  skin: {
    1: '#f1d0c0',
    2: '#e6b8a3',
    3: '#bd8b6f',
    4: '#c7886a',
    5: '#9d714f',
    6: '#412e27',
  },
  hair: {
    1: '#3D3637',
    2: '#6C5F5B',
    3: '#A18066',
    4: '#ADADAD',
    5: '#E4E4E4',
    6: '#FFFFFF',
    7: '#e45241',
    8: '#d4a45d',
    9: '#ffd667',
    10: '#7a1e1e',
    11: '#32acaf',
    12: '#662df5',
  },
  top: {
    1: '#000000',
    2: '#3D3D3D',
    3: '#86e2c1',
    4: '#FFFFFF',
    5: '#10105f',
    6: '#213ed4',
    7: '#b01a0a',
    8: '#1ad05a',
    9: '#ffd156',
    10: '#ff4b37',
    11: '#a711dc',
    12: '#ed345e',
  },
};

export const characterGen3 = {
  skin: {
    1: {
      color: '#f1d0c0',
      roughness: 0.5,
      metalness: 0,
      iridescence: 0,
    },
    2: {
      color: '#e6b8a3',
      roughness: 0.5,
      metalness: 0,
      iridescence: 0,
    },
    3: {
      color: '#bd8b6f',
      roughness: 0.5,
      metalness: 0,
      iridescence: 0,
    },
    4: {
      color: '#c7886a',
      roughness: 0.5,
      metalness: 0,
      iridescence: 0,
    },
    5: {
      color: '#9d714f',
      roughness: 0.5,
      metalness: 0,
      iridescence: 0,
    },
    6: {
      color: '#412e27',
      roughness: 0.5,
      metalness: 0,
      iridescence: 0,
    },
    7: {
      color: '#111111',
      roughness: 0.25,
      metalness: 0,
      iridescence: 0,
      icon: Thumb_Skin_plastic,
    },
    8: {
      color: '#c4c5c5',
      roughness: 0.05,
      metalness: 1,
      iridescence: 0,
      icon: Thumb_Skin_chrome,
    },
    9: {
      color: '#ffe29b',
      roughness: 0.05,
      metalness: 1,
      iridescence: 0,
      icon: Thumb_Skin_gold,
    },
    10: {
      color: '#999999',
      roughness: 0.25,
      metalness: 1,
      iridescence: 1,
      icon: Thumb_Skin_iridescent,
    },
  },
};
